<template>
  <CategoryProductsList
    :category="category"
    :products="products"
    :is-loading="isLoading"
    link-from-param="machine"
    :link-from-value="machineId"
  />
</template>

<script setup lang="ts">
  import { Category } from '@/api/requests/CategoriesList';
  import CategoryProductsList from '@/components/catalog/CategoryProductsList.vue';
  import { getProductsForMachine } from '@/services/product/api';
  import { Product } from '@/services/product/types';
  import { onMounted, ref } from 'vue';

  const props = defineProps<{
    category: Category;
    machineId: number;
  }>();

  const products = ref<Product[] | null>(null);
  const isLoading = ref(false);

  async function loadProducts() {
    isLoading.value = true;

    const response = await getProductsForMachine({
      machineId: props.machineId,
      categoryId: props.category.id
    });

    products.value = response
      .map(item => ({
        ...item.product,
        in_stock: item.in_stock,
        attributes: {
          ...item.product.attributes,
          price: item.price
        }
      }))
      .sort((a, b) => (b.in_stock ? 1 : -1) - (a.in_stock ? 1 : -1));

    isLoading.value = false;
  }

  onMounted(() => {
    loadProducts();
  });
</script>
